<script lang="ts">
    import { createEventDispatcher, onDestroy } from 'svelte';
    import { fade } from 'svelte/transition';
    import { Rive, Layout, Fit, Alignment } from '@rive-app/canvas';
    import { RIVE_ANIMATIONS, getAnimationParams } from '@src/utils/animations.js';
    // import audio_transition_bonus_game_normal from '@src/assets/sounds/transition.mp3';
    // import audio_transition_bonus_game_super from '@src/assets/sounds/transition_super.mp3';
    import { BONUS_GAMES } from '@root/src/constants';
    import { BonusGame } from '@root/src/types';
    import { playAudio } from '@root/src/utils/audio';

    export let bonusGameType: BonusGame; //1 - BONUS_GAMES.PLINKO , 2 - BONUS_GAMES.FORTUNE_WHEEL, 3 - BONUS_GAMES.CASH_REELS, 4 - BONUS_GAMES.BALL_SPIN

    const stateMachineName = 'State Machine 1';
    const artboardName = 'crazy_transition';
    const bonusTypeNumber = 'bonus_switch';

    const customDPR = 1;
    const dispatch = createEventDispatcher();

    let transitionRiveInstance;
    // let sound;

    const getTypeBonusGame = (bonusGameType: BonusGame) => {
        switch (bonusGameType) {
            case BONUS_GAMES.PLINKO:
                return 1;
            case BONUS_GAMES.FORTUNE_WHEEL:
                return 2;
            case BONUS_GAMES.CASH_REELS:
                return 3;
            case BONUS_GAMES.BALL_SPIN:
                return 4;

            default:
                console.log('Unknown bonus game type', bonusGameType);
                return -1;
        }
    };

    const runAnimationTransition = canvas => {
        if (transitionRiveInstance) {
            transitionRiveInstance.cleanup();
        }

        transitionRiveInstance = new Rive({
            src: RIVE_ANIMATIONS.BONUS_TRANSITION,
            stateMachines: stateMachineName,
            canvas: canvas,
            autoplay: true,
            artboard: artboardName,
            shouldDisableRiveListeners: false,
            layout: new Layout({
                fit: Fit.Cover,
                alignment: Alignment.Center
            }),
            onLoad: () => {
                transitionRiveInstance.resizeDrawingSurfaceToCanvas(customDPR);
                const animationParams = getAnimationParams(transitionRiveInstance, stateMachineName, [bonusTypeNumber]);

                animationParams[bonusTypeNumber].value = getTypeBonusGame(bonusGameType);
                playAudio('audio_transition');
            },
            onStateChange: event => {
                const eventName = event?.data?.[0];
                // console.log('WIN STATE:', eventName);

                if (eventName?.match(/end/)) {
                    dispatch('end');
                }
            }
        });

        // transitionRiveInstance.on(EventType.RiveEvent, event => {
        //     if (event.data?.name === 'end') {
        //         dispatch('end');
        //     }
        // });
    };

    onDestroy(() => {
        transitionRiveInstance?.cleanup();
        // sound?.unload();
    });
</script>

<div class="fixed inset-0 z-9999 mx-auto bg-gradient-to-b from-game-backdrop to-black" out:fade>
    <canvas class="h-full w-full" width="500" height="570" use:runAnimationTransition />
</div>
